import { apiClient } from './authService';
import { buildDownloadUrl } from './downloadUrl';

const toFormData = ({
  file,
  scaleFactor,
  creativity,
  maxFileSizeMb,
  sourceJobId,
  sourceVariant,
  workspaceId,
}) => {
  const hasUpload = Boolean(file);
  const hasSource = Boolean(sourceJobId && sourceVariant);
  if (!hasUpload && !hasSource) {
    throw new Error('Upscale job requires an uploaded file or source artifact reference.');
  }
  if (hasUpload && hasSource) {
    throw new Error('Provide either file upload or source artifact reference, not both.');
  }

  const formData = new FormData();
  if (file) {
    formData.append('file', file);
  }
  if (sourceJobId) {
    formData.append('source_job_id', sourceJobId);
  }
  if (sourceVariant) {
    formData.append('source_variant', sourceVariant);
  }
  if (workspaceId) {
    formData.append('workspace_id', workspaceId);
  }

  if (typeof scaleFactor === 'number') {
    formData.append('scale_factor', String(scaleFactor));
  }

  if (typeof creativity === 'number') {
    formData.append('creativity', String(creativity));
  }

  if (typeof maxFileSizeMb === 'number') {
    formData.append('max_file_size_mb', String(maxFileSizeMb));
  }

  return formData;
};

export const upscaleService = {
  async createJob({
    file = null,
    scaleFactor = 2.0,
    creativity = 0.0,
    maxFileSizeMb = 50.0,
    sourceJobId = null,
    sourceVariant = null,
    workspaceId = null,
  }) {
    const formData = toFormData({
      file,
      scaleFactor,
      creativity,
      maxFileSizeMb,
      sourceJobId,
      sourceVariant,
      workspaceId,
    });

    const response = await apiClient.post('/upscale/image', formData);

    return response.data;
  },

  async getJobStatus(jobId) {
    const response = await apiClient.get(`/upscale/job/${encodeURIComponent(jobId)}/status`);
    return response.data;
  },

  async getJobResult(jobId) {
    const response = await apiClient.get(`/upscale/job/${encodeURIComponent(jobId)}/result`);
    return response.data;
  },

  async downloadUpscaled(jobId) {
    const response = await apiClient.get(
      `/upscale/job/${encodeURIComponent(jobId)}/download/upscaled`,
      {
        responseType: 'blob',
      }
    );
    return response.data;
  },

  buildDownloadUrl(jobId, type = 'upscaled') {
    if (!jobId) return null;

    const fileType = type === 'original' ? 'original' : 'upscaled';
    return buildDownloadUrl(`/upscale/job/${encodeURIComponent(jobId)}/download/${fileType}`);
  },
};

export default upscaleService;
